import React from "react";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import UserService from '../../services/user.service';
import { useForm } from "react-hook-form";
import TitleCombobox from "./TitleCombobox";

const TitleModal = (props) => {
  const { handleSubmit, watch, setValue } = useForm({
    defaultValues: { title: props.user.title || "", userId: props.user.id },
  });

  const titleValue = watch("title");

  const onSubmit = async (data) => {
    await UserService.updateTitle({ userId: props.user.id, title: data.title });
    props.closeTitleModal(false);
  };

  const titleModalClose = () => {
    props.closeTitleModal(false);
  };

  return (
    <Modal show={props.show} onHide={titleModalClose} enforceFocus={false}>
    <Modal.Header closeButton>
      <Modal.Title>Update Title<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>

            <Form onSubmit={handleSubmit(onSubmit)}>
              <TitleCombobox
                name="title"
                value={titleValue}
                onChange={(e) => setValue("title", e.target.value, { shouldDirty: true })}
              />
              <Modal.Footer>
                <Button variant="secondary" onClick={titleModalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit(onSubmit)} type="submit">
                  Update Title
                </Button>
              </Modal.Footer>
            </Form>


    </Modal.Body>
    </Modal>
  );
};

export default TitleModal;
